function capitalize(value: string) {
  return value.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
    letter.toUpperCase()
  );
}

export default capitalize;
